
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gkA1YfLGykh6thZdrrM4FPpRlSKNbzae9QQtN77t_45k7kMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexCodWHCEKcK4OIFJG0184_ASemj3nvL3Q4QhoJ8HJ3l8Meta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchFYVQH6_AoxE6Zav7CBDDO2rDkNPIeZT8FMt128OXBEoMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index72YZ8BJaNSuiC2LjUNqPl1gYLW_xV1FnjeSy5dopAEAMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93RYlgSsS9t8kEIGlRtEcXRXhEY9NP7A58atSBMt3p0tUMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index_45QQDhPA2kYEQ0eN_459JBIikcsacwHG1ja7ldQsmbyNtUMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93T0Gfi9Azy0xM50s0i1TXoqLOCAYK4dHi24sNbWeOWfcMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index4Kf_0qtoBJJjIdGITG7FO9HGU51JkJA_45iaoAWXVkQ6MMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_931A6ve37E9VwrzCwL_rA1FZbZn_1VfIiqDdVMRaAJ9qEMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexKZDlwBmNN81N7BBoPo_YJw_454c_mRxotQO5CXhtH8ji8Meta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexrZEb9KbzHlljZL1MDyMWrCpe9uGvNGc_45Q8_LneVk1CwMeta } from "/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index_45QQDhPA2kYEQ0eN_459JBIikcsacwHG1ja7ldQsmbyNtUMeta || {},
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index4Kf_0qtoBJJjIdGITG7FO9HGU51JkJA_45iaoAWXVkQ6MMeta || {},
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexKZDlwBmNN81N7BBoPo_YJw_454c_mRxotQO5CXhtH8ji8Meta || {},
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexrZEb9KbzHlljZL1MDyMWrCpe9uGvNGc_45Q8_LneVk1CwMeta || {},
    component: () => import("/codebuild/output/src2121541655/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]